import { Controller } from "@hotwired/stimulus"

// Brings its element on screen and focuses it as soon as it appears. Meant
// for the error summary above a long admin form: after a failed submit the
// page can sit wherever the save button was, leaving the box just out of
// view. The zero-delay timeout lets Turbo finish its own scroll and focus
// restoration first, so this one wins (a frame callback would not do: it
// never fires in a background tab). The jump is instant because the admin
// page scrolls smoothly and two animated scrolls would fight.
//
// Connects to data-controller="scroll-into-view"
export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.scrollIntoView({ block: "start", behavior: "instant" })
      this.element.focus({ preventScroll: true })
    }, 0)
  }
}
